var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.125,
    height: 21.125,
    viewBox: "0 0 21.125 21.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Gemist_icoon",
    "data-name": "Gemist icoon",
    d: "M23.5,18.9h0l-6.409-6.409L23.5,6.082h0a.662.662,0,0,0,0-.933L20.476,2.121a.662.662,0,0,0-.933,0h0L13.133,8.53,6.725,2.121h0a.662.662,0,0,0-.933,0L2.764,5.148a.662.662,0,0,0,0,.933h0l6.409,6.409L2.764,18.9h0a.662.662,0,0,0,0,.933l3.027,3.027a.662.662,0,0,0,.933,0h0l6.409-6.409,6.409,6.409h0a.662.662,0,0,0,.933,0L23.5,19.833a.662.662,0,0,0,0-.933Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#bebebe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.aed5eb05.svg";
export { ForwardRef as ReactComponent };